import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
require("./assets/custom");

Vue.config.productionTip = false;
window.Event = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");


// const files = require.context('./', true, /\.vue$/i)

// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

if ("serviceWorker" in navigator && process.env.NODE_ENV !== "development")
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.BASE_URL}service-worker.js`)
      .then(() => {
        if (process.env.NODE_ENV === "development") console.log("App is being served from cache by a service worker.");
      })
      .catch(registrationError => {
        if (process.env.NODE_ENV === "development") console.log("SW registration failed: ", registrationError);
      });
  });
